// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".panel__body[data-v-885e4b6e] {\n  height: 290px;\n}\n", "",{"version":3,"sources":["webpack://./packages/completeTable/component/panel.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf","sourcesContent":[".panel__body[data-v-885e4b6e] {\n  height: 290px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
